import { ReactNode } from "react";
import { Button, makeStyles, Snackbar } from "@material-ui/core";
import Alert, { TAlertType } from "./Alert";
import { lang } from "../../../i18nLang";

const useStyles = makeStyles({
  warningMessage: {
    "& .MuiAlert-message > *, & .MuiButton-label": {
      color: "rgba(0, 0, 0, 0.87)",
    },
  },
});

interface IProps {
  open: boolean;
  onClose: Function;
  autoHideDuration?: number;
  message: ReactNode;
  type: TAlertType | "default";
  [property: string]: any;
}

const MessageSnack = ({ onClose, message, type, ...props }: IProps) => {
  const classes = useStyles();
  const isDefault = type === "default";

  const handleClose = (ev, reason) => {
    if (reason === "clickaway") return;
    onClose(ev);
  };

  const actionRender = () => (
    <Button size="small" onClick={(ev) => handleClose(ev, "buttonClick")}>
      {lang("close")}
    </Button>
  );

  if (isDefault)
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        {...props}
        onClose={handleClose}
        action={actionRender()}
        message={message}
      />
    );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      {...props}
      className={type === "warning" ? classes.warningMessage : undefined}
      onClose={handleClose}
    >
      <Alert icon={false} type={type} action={actionRender()}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MessageSnack;
